// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format13 } from '../../constants';

/** Madagascar */
const MG: PhoneNumberData = [261, 'MG', 9, format13];

export default MG;
